<template>
  <div class="login-wrapper">
    <div class="login-box">
      <div class="header">
        <h1 class="title">开发者端</h1>
        <p class="subtitle">设置您的新密码</p>
      </div>

      <el-form :model="forgetForm" :rules="rules" ref="loginFromRef" label-position="top">
        <div class="form-content">
          <el-form-item prop="password">
            <el-input 
              prefix-icon="el-icon-lock"
              placeholder="请输入新密码 (至少6位)" 
              v-model="forgetForm.password" 
              type="password"
              show-password
              @input="changeInput">
            </el-input>
          </el-form-item>

          <el-form-item prop="repassword">
            <el-input 
              prefix-icon="el-icon-circle-check"
              placeholder="请再次确认新密码" 
              v-model="forgetForm.repassword" 
              type="password"
              show-password
              @input="changeInput">
            </el-input>
          </el-form-item>

          <div class="action-links">
            <router-link to="/login">想起密码？立即登录</router-link>
          </div>

          <el-form-item>
            <el-button type="primary" class="submit-btn" @click="change">更 改 密 码</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const validatePass2 = (rule, value, cb) => {
      if (value === '') {
        cb(new Error('请再次输入密码'));
      } else if (value !== this.forgetForm.password) {
        cb(new Error('两次输入密码不一致!'));
      } else {
        cb();
      }
    };
    return {
      forgetForm: {
        password: "",
        repassword: "",
        token:""
      },
      rules: {
        password: [
          { required: true, message: "请输入密码", trigger: ["blur", "change"] },
          { min: 6, max: 16, message: "长度在 6 到 16 个字符", trigger: ["blur", "change"] },
        ],
        repassword: [
          { required: true, message: "请确认密码", trigger: ["blur", "change"] },
          { validator: validatePass2, trigger: ["blur", "change"] }
        ],
      },
    };
  },
  created(){
    this.forgetForm.token = this.$route.query.token
  },
  methods: {
    change() {
      this.$refs.loginFromRef.validate(async (value) => {
        if (!value) return this.$message.error("请检查输入信息");
        //console.log(this.forgetForm);
        const res = await this.$http.post("change", this.forgetForm);
        //console.log(res);
        if (res.data.meta.status !== 200) {
          //console.log(11);
          return this.$message.error(res.data.meta.msg);
        } else {
          //console.log(22);
          this.$message.success(res.data.meta.msg);
          setTimeout(()=>{
            return this.$router.push("/login");
          },2000)
        }
      });
    },
    changeInput(e){
      this.$forceUpdate()
    }
  },
};
</script>

<style lang="less" scoped>

.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
  box-sizing: border-box;
}


.login-box {
  width: 380px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  padding: 40px 30px;
  box-sizing: border-box;
}


.header {
  text-align: center;
  margin-bottom: 30px;
  .title {
    font-size: 24px;
    color: #303133;
    margin: 0 0 10px 0;
    font-weight: 600;
  }
  .subtitle {
    font-size: 14px;
    color: #909399;
  }
}

.action-links {
  text-align: right;
  margin: -10px 0 20px 0;
  a {
    font-size: 14px;
    color: #409eff;
    text-decoration: none;
    font-weight: 500;
    &:hover { text-decoration: underline; }
  }
}

.submit-btn {
  width: 100%;
  height: 42px;
  font-size: 16px;
  border-radius: 8px;
  letter-spacing: 2px;
}

.login_container {
  background-color: #2b4b6b;
  height: 100%;
  // display: flex;
  // width: 100%;
  // justify-content: center;
  // align-items:center;/*垂直居中*/
  // flex-shrink: 0;

  h4{
    margin: 20px 0;
  }
  a {
    text-decoration: none;
    color: #409eff;
    font-size: 15px;
  }
  .title {
    text-align: center;
    h2 {
      margin: 20;
    }
  }

  .el-form {
    // width: 100%;
    height: 360px;
    background-color: #fff;
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
    border-top: 1px solid;
    border-radius: 5px;
    padding: 0 20px;
    .form-content {
      margin-top: 25px;
      .info {
        margin-top: -4px;
        display: flex;
        justify-content: space-between;
      }
    }
    .el-form-item {
      margin-top: 30px;
      .left,
      .code {
        float: left;
        width: 50%;
        height: 40px;
        img {
          // border: 1px solid #eee;
          width: 100%;
          height: 100%;
          // margin-left: 55px;
        }
      }
      .el-button {
        float: right;
        margin-left: 20px;
        width: 100%;
        margin-top: -15px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  /deep/ .el-input__inner {
    font-size: 16px !important;
  }
  .login-wrapper {
    background: #ffffff;
    align-items: flex-start;
    padding-top: 15vh;
  }
  .login-box {
    width: 100%;
    max-width: 100%;
    box-shadow: none;
    padding: 20px;
  }
}
</style>